const React = require('react');
const { useTranslation } = require('react-i18next');
const { TimeFrameWrapper } = require('TimeFrameWrapper');
const { RadioButtons, RelatedSettings } = require('./PlannerModeSelectors');
const { plannerType } = require('@managers/planningManager');

function getPlannerType(field) {
  if (field.settings.planner_settings) {
    return field.settings.planner_settings.type;
  }
  if (field.settings.is_rolling_fit_active) {
    return plannerType.DAILY_RECOMMENDATION;
  }
  return plannerType.DISABLED;
}

export function PlannerWrapper({
  field,
  handleSettingsChange,
  handleIrrigationTimeFramesChange,
  handlePlannerSettingsChange,
  onTimeFrameEditingChange,
  userData,
}) {
  if (!field) {
    return null;
  }
  const { t } = useTranslation();
  const currentPlannerType = getPlannerType(field);

  return (
    <div className='ml-2 mt-3 mb-3'>
      <div className='font-weight-bold text-size-20 mb-2' htmlFor='planner'>
        {t('Planner')}
      </div>
      <RadioButtons
        currentPlannerType={currentPlannerType}
        handlePlannerSettingsChange={handlePlannerSettingsChange}
      />
      <RelatedSettings
        fieldId={field.id}
        currentPlannerType={currentPlannerType}
        is_dynamic_planner_active={field.settings.is_dynamic_planner_active}
        handleSettingsChange={handleSettingsChange}
        userLengthUnits={userData.length}
        handlePlannerSettingsChange={handlePlannerSettingsChange}
        plannerSettings={field.settings.planner_settings}
      />
      <TimeFrameWrapper
        key={currentPlannerType}
        field={field}
        currentPlannerType={currentPlannerType}
        onIrrigationTimeFramesChange={handleIrrigationTimeFramesChange}
        onEditingChange={onTimeFrameEditingChange}
        userData={userData}
      />
    </div>
  );
}
